import { apiClient } from './client';
import type { ClientsPageMeta } from './clients';

/**
 * Пользователь ЛК — /portal-users (см. докблок PortalUserController в
 * Laravel, 1:1 старый Orchid CustomerUserListScreen).
 */
export interface PortalUserRow {
  id: number;
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  email: string | null;
  /** Компания, к которой относится пользователь. */
  client: string | null;
  clientId: number | null;
  role: string | null;
  /** Название роли из справочника; слаг показывать не нужно. */
  roleName: string | null;
  status: string | null;
  login: string | null;
}

export interface FetchPortalUsersParams {
  search?: string;
  role?: string;
  status?: string;
  sort?: string;
  page?: number;
}

export interface PortalUsersPage {
  items: PortalUserRow[];
  meta: ClientsPageMeta;
}

export async function fetchPortalUsers(
  params: FetchPortalUsersParams = {},
): Promise<PortalUsersPage> {
  const { data } = await apiClient.get<PortalUsersPage>('/portal-users', { params });
  return data;
}

export interface PortalUserFilters {
  roles: { value: string; label: string }[];
  statuses: { value: string; label: string }[];
}

export async function fetchPortalUserFilters(): Promise<PortalUserFilters> {
  const { data } = await apiClient.get<PortalUserFilters>('/portal-users/filters');
  return data;
}
